import { forwardRef } from "react";
import { withSubComponents } from "../../utilities/withSubComponents";
import { Field } from "./Field";
import { SharedProps } from "./SharedProps";
import { Input } from "./Input";
import { Placeholder } from "./Placeholder";
import { InputBaseProps, RefComponent } from "capitalrx-components-2.0/lib/forms";


export interface SearchTextboxProps extends InputBaseProps<string | null>, SharedProps {}

/**
 * The `SearchTextbox` component sub components.
 */
export interface SearchTextboxSubComponents {
  /**
   * A React Hook Form compatible Textbox Field component. For more information, see the documentation for
   * the <a href="https://react-hook-form.com/api">React Hook Form API</a>.
   */
  readonly Field: typeof Field;

  /**
   * A placeholder component for the Textbox which can be displayed while loading.
   */
  readonly Placeholder: typeof Placeholder;
}

export const SearchTextbox = withSubComponents<RefComponent<HTMLInputElement, SearchTextboxProps>, SearchTextboxSubComponents>(
  {
    Field,
    Placeholder,
  },
  forwardRef<HTMLInputElement, SearchTextboxProps>(function Textbox(props, ref) {
    return <Input {...props} ref={ref} type="text" />;
  }),
);
